var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-divider',{staticClass:"mx-1 my-1",attrs:{"vertical":""}})}
var staticRenderFns = []

export { render, staticRenderFns }